import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import shapeTypes from '../../constants/ShapeConstants';
import mouseUtils from '../../components/utils/MouseUtils';
import animationManager from '../utils/AnimationManager';
import groupManager from '../utils/GroupManager';
import locales from '../../locales/LocalesManager';

const GroupButtonContent = React.createClass({
    getInitialState () {
        return {
            isMenuButtonOver: false
        };
    },
    onMenuButtonMouseIn () {
        this.setState({
            isMenuButtonOver: true
        });
    },
    onMenuButtonMouseOut() {
        this.setState({
            isMenuButtonOver: false
        });
    },
    onGroupElements(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        groupManager.groupUngroup();
    },
    getSelectedShapes() {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;
        var selection = [];

        if (!shapes)
            return selection;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].isSelected == true)
                selection.push(shapes[i]);

        return selection;
    },
    getPosition(shapeModel) {
        const scaleProperties = this.props.scaleProperties;
        var i;
        var selectedShapes = this.getSelectedShapes();
        var xMin, xMax, yMin, yMax;

        for (i=0; i<selectedShapes.length; i++) {
            if (i==0) {
                if (selectedShapes[i].type == shapeTypes.LINE || selectedShapes[i].type == shapeTypes.CURVE) {
                    xMin = Math.min(selectedShapes[i].x1, selectedShapes[i].x2);
                    xMax = Math.max(selectedShapes[i].x1, selectedShapes[i].x2);

                    yMin = Math.min(selectedShapes[i].y1, selectedShapes[i].y2);
                    yMax = Math.max(selectedShapes[i].y1, selectedShapes[i].y2);
                } else {
                    xMin = selectedShapes[i].x;
                    xMax = selectedShapes[i].x + selectedShapes[i].width;

                    yMin = selectedShapes[i].y;
                    yMax = selectedShapes[i].y + selectedShapes[i].height;
                }
            }  else {
                if (selectedShapes[i].type == shapeTypes.LINE || selectedShapes[i].type == shapeTypes.CURVE) {
                    var minVal = Math.min(selectedShapes[i].x1, selectedShapes[i].x2);
                    var maxVal = Math.max(selectedShapes[i].x1, selectedShapes[i].x2);

                    if (minVal < xMin)
                        xMin = minVal;

                    if (maxVal > xMax)
                        xMax = maxVal;

                    minVal = Math.min(selectedShapes[i].y1, selectedShapes[i].y2);
                    maxVal = Math.max(selectedShapes[i].y1, selectedShapes[i].y2);

                    if (minVal < yMin)
                        yMin = minVal;

                    if (maxVal > yMax)
                        yMax = maxVal;
                } else {
                    if (selectedShapes[i].x < xMin)
                        xMin = selectedShapes[i].x;

                    if (selectedShapes[i].x + selectedShapes[i].width > xMax)
                        xMax = selectedShapes[i].x + selectedShapes[i].width;

                    if (selectedShapes[i].y < yMin)
                        yMin = selectedShapes[i].y;

                    if (selectedShapes[i].y + selectedShapes[i].height > yMax)
                        yMax = selectedShapes[i].y + selectedShapes[i].height;
                }
            }
        }

        var centerX = xMin + (xMax - xMin) / 2;
        var centerY = yMin + (yMax - yMin) / 2;
        var limitTop = scaleProperties.topY;
        var limitBottom = scaleProperties.topY + 450 * scaleProperties.scale;
        var limitLeft = scaleProperties.topX;
        var limitRight = scaleProperties.topX + 800 * scaleProperties.scale;

        var newPos = {left: scaleProperties.topX + centerX * scaleProperties.scale - properties.GROUP_BUTTON_WIDTH / 2, top: scaleProperties.topY + centerY * scaleProperties.scale - properties.GROUP_BUTTON_HEIGHT / 2};

        if (newPos.left < limitLeft || (newPos.left + properties.GROUP_BUTTON_WIDTH) > limitRight)
            newPos.left = limitLeft + (limitRight - limitLeft) / 2 - properties.GROUP_BUTTON_WIDTH / 2;

        if (newPos.top < limitTop || (newPos.top + properties.GROUP_BUTTON_HEIGHT) > limitBottom)
            newPos.top = limitTop + (limitBottom - limitTop) / 2 - properties.GROUP_BUTTON_HEIGHT / 2;

        return newPos;
    },
    render() {
        var selectedShapes = this.getSelectedShapes();

        if (selectedShapes.length <= 1 || animationManager.clone)
            return (<div/>);

        var menuButtonFrameColor;
        var textColor;

        if (this.state.isMenuButtonOver == true) {
            menuButtonFrameColor = properties.SLIDE_FRAME_HOVER_COLOR;
            textColor = menuButtonFrameColor;
        } else {
            menuButtonFrameColor = '#dadada';
            textColor = 'black';
        }

        const position = this.getPosition();
        const menuButtonStyle = {
            position: 'absolute',
            top: position.top,
            left: position.left,
            width: properties.GROUP_BUTTON_WIDTH,
            height: properties.GROUP_BUTTON_HEIGHT,
            background: '#f3f3f3',
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: menuButtonFrameColor,
            borderRadius: 5,
            userSelect: 'none',
            WebkitUserSelect: 'none',
            cursor: 'pointer'
        };

        const spanStyle = {
            position: 'absolute',
            top: 10,
            left: 5,
            width: menuButtonStyle.width - 10,
            height: 20,
            color: textColor,
            textAlign: 'center',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 16,
            fontWeight: 'bold'
        };

        return (
            <div style={menuButtonStyle} onTouchEnd={this.onGroupElements} onClick={this.onGroupElements} onMouseOver={this.onMenuButtonMouseIn} onMouseOut={this.onMenuButtonMouseOut}>
                <span style={spanStyle}>{locales.getCaption('GroupButton', 'other')}</span>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const slideModel = state.currentSlide.model;

    return {
        slideModel
    };
}

export const GroupButton = connect(mapStateToProps)(GroupButtonContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/GroupButton.js
 **/